import React, { Component } from 'react'
import { message } from 'antd/lib/index'
import TransactionsApi from '../../../api/Finance/Transactions'
import InvoicesApi from '../../../api/Sales/Invoices'
import ReceiptsApi from '../../../api/Sales/Receipts'
import Payments from './Payments'
import { isEmpty, pick, set, sumBy } from 'lodash'
import { numVal } from '../../../modules/Utils'
import moment from 'moment'

class PaymentsCont extends Component {
  state = {
    list: [],
    invoices: [],
    transaction: {},
    receipt: {},
    calculation: { allocated: 0, remaining: 0, total: 0, contract: 0 },
    fetching: false,
    visible: false,
    submitting: false,
  }
  api = new TransactionsApi()
  invoicesApi = new InvoicesApi()
  receiptsApi = new ReceiptsApi()
  formRef = React.createRef()

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const list = await this.api.listPayment('_key,date,amount,notes,remittance,company,bank,currency,transactionType')
      //  const list = data.filter(p => p.type === 'credit' && p.allocated !== true)
      this.setState({
        fetching: false,
        list,
        cached: list,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }
  fetchTransaction = async (key) => {
    try {
      this.setState({
        visible: true,
        type: 'new',
        fetchingTransaction: true,
      })
      const transaction = await this.api.read(key)
      this.setState({
        fetchingTransaction: false,
        transaction,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetchingTransaction: false, visible: false })
    }
  }
  onShow = async (e, transaction) => {
    this.setState({
      visible: true,
    })
    await this.fetchTransaction(transaction._key)
  }
  onCancel = () => {
    this.setState({
      visible: false,
      transaction: {},
      invoices: [],
      receipt: {},
      calculation: { allocated: 0, remaining: 0, total: 0, contract: 0 },
    })
    this.formRef.current.resetFields()
  }
  onChangeContract = async (_id) => {
    if (!isEmpty(_id)) {
      try {
        this.setState({
          fetchingInvoices: true,
        })
        let invoices = await this.invoicesApi.unpaid(_id)
        invoices = invoices.map((l) => ({
          ...l,
          ...this.state.invoices.find((ll) => l._id === ll._id),
        }))
        const total = sumBy(invoices, (i) => numVal(i, 'subTotal.gross'))
        const allocated = sumBy(invoices, (i) => numVal(i, 'amount'))
        let calculation = { ...this.state.calculation }
        calculation.remaining = numVal(this.state, 'transaction.amount') - allocated - numVal(calculation, 'contract')
        calculation.total = total
        calculation.allocated = allocated
        this.setState({
          invoices,
          contract: _id,
          cachedInvoices: invoices,
          calculation,
          fetchingInvoices: false,
        })
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({ fetchingInvoices: false })
      }
    }
  }
  onChangeContractAllocated = (value) => {
    this.setState((prevState, props) => {
      let calculation = prevState.calculation
      calculation.contract = numVal({ value }, 'value')
      calculation.remaining =
        numVal(prevState, 'transaction.amount') - (calculation.allocated + numVal({ value }, 'value'))
      return { calculation }
    })
  }
  submit = async () => {
    await this.checkForm()
    try {
      let { receipt } = { ...this.state }
      receipt.transaction = pick(this.state.transaction, ['_id'])
      receipt.date = moment()
      const lines = { ...this.state }.invoices
        .filter((i) => numVal(i, 'amount') !== 0 || numVal(i, 'discount') > 0 || numVal(i, 'wtax.tax') > 0)
        .map((i) => ({
          ...pick(i, ['amount', 'discount']),
          invoice: pick(i, ['_id', '_rev', 'code', 'activity', 'date']),
          receipt: { _id: 'temp' },
        }))
      if (this.state.calculation.remaining !== 0) {
        message.error('Make sure that remaining is equal to zero 0.')
        return
      }
      this.setState({
        submitting: true,
      })
      await this.receiptsApi.createWithLines({ doc: receipt, lines })
      this.setState({
        submitting: false,
      })
      this.onCancel()
      message.success('Receipt Created')
      await this.fetch()
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  checkForm = () => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            receipt: Object.assign({}, this.state.receipt, values),
          })
          res(true)
        }
      })
    })
  }
  receiptsOps = {
    reject: async (receipt) => {
      try {
        this.setState({
          fetching: true,
        })
        await this.receiptsApi.operation('reject', pick(receipt, ['_id', '_key', '_rev']))
        this.setState({
          fetching: false,
        })
        await this.fetchReceipts()
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({ fetching: false })
      }
    },
    remove: async (receipt) => {
      try {
        this.setState({
          fetching: true,
        })
        await this.receiptsApi.remove(pick(receipt, ['_id', '_key', '_rev']))
        this.setState({
          fetching: false,
        })
        await this.fetchReceipts()
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({ fetching: false })
      }
    },
    approve: async (receipt) => {
      try {
        this.setState({
          fetching: true,
        })
        await this.receiptsApi.operation('approve', pick(receipt, ['_id', '_key', '_rev']))
        this.setState({
          fetching: false,
        })
        await this.fetchReceipts()
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({ fetching: false })
      }
    },
    submit: async (receipt) => {
      try {
        this.setState({
          fetching: true,
        })
        await this.receiptsApi.operation('submit', pick(receipt, ['_id', '_key', '_rev']))
        this.setState({
          fetching: false,
        })
        await this.fetchReceipts()
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({ fetching: false })
      }
    },
  }
  invoicesOps = {
    cancel: (_key) => {
      let newData = [...this.state.invoices]
      let target = newData.find((item) => _key === item._key)
      if (target) {
        target = { ...this.state.cached.find((item) => _key === item._key) }
        delete target.editable
        if (Object.keys(target).length === 1 && Object.keys(target)[0] === '_key') this.remove(target._key)
        else this.setState({ invoices: newData })
      }
    },
    remove: (_key) => {
      let newData = [...this.state.invoices]
      newData = newData.filter((item) => _key !== item._key)
      const total = sumBy(newData, (i) => numVal(i, 'subTotal.net'))
      const allocated = sumBy(newData, (i) => numVal(i, 'amount'))
      let calculation = { ...this.state.calculation }
      calculation.remaining = numVal(this.state, 'transaction.amount') - allocated - numVal(calculation, 'contract')
      calculation.total = total
      calculation.allocated = allocated
      this.setState({ invoices: newData, calculation })
    },
    edit: (_key) => {
      const newData = [...this.state.invoices]
      const target = newData.filter((item) => _key === item._key)[0]
      if (target) {
        target.editable = true
        this.setState({ invoices: newData })
      }
    },
    save: (_key) => {
      const newData = [...this.state.invoices]
      const target = newData.find((item) => _key === item._key)
      if (target) {
        delete target.editable
        target.newBalance =
          numVal(target, 'subTotal.gross') -
          (numVal(target, 'amount') + numVal(target, 'paid') + numVal(target, 'discount') + numVal(target, 'wtax.tax'))
        const amount = numVal(this.state, 'transaction.amount')
        const allocated = sumBy(newData, (i) => numVal(i, 'amount'))
        let calculation = { ...this.state.calculation }
        calculation = {
          ...calculation,
          allocated,
          remaining: amount - (numVal(calculation, 'contract') + allocated),
        }
        this.setState({
          invoices: newData,
          calculation,
          cached: newData.map((i) => ({ ...i })),
        })
      }
    },
  }
  handleChange = (value, _key, column) => {
    const newData = [...this.state.invoices]
    const target = newData.find((item) => _key === item._key)
    if (target) {
      set(target, column, value)
      this.setState({ invoices: newData })
    }
  }
  onChangeCompany = (company) => {
    this.filterCompany(company)
    this.setState({
      company,
    })
  }
  filterCompany = (_id) => {
    this.setState((prevState, props) => ({
      list: _id ? prevState.cached.filter((i) => i.company._id === _id) : prevState.cached,
    }))
  }

  render() {
    return (
      <Payments
        {...this.state}
        {...pick(this, [
          'fetch',
          'fetchTransaction',
          'onChangeContract',
          'onChangeCompany',
          'filterCompany',
          'onChangeContractAllocated',
          'fetchReceipts',
          'onCancel',
          'onShow',
          'onEdit',
          'submit',
          'handleChange',
          'invoicesOps',
          'receiptsOps',
          'update',
          'formRef',
        ])}
      />
    )
  }
}

PaymentsCont.propTypes = {}
PaymentsCont.defaultProps = {}

export default PaymentsCont
